import React from 'react'
import { Link } from 'react-router-dom'

function ErrorPage () {
  return (
    <div>
    <section className="section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    <div className="error-page text-center">
                        <div className="image">
                            <img src="/tm/react/toolways/assets/images/error_404.png" className="img-fluid" alt="img"/>
                        </div>
                        <h1 className="title">Page Not Found</h1>
                        <p>Sorry The Page You Are Looking For Does Not Exist</p>
                        <Link to="/" className="thm-btn btn-rounded thm-bg-color-one">Back To Home</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default ErrorPage